<template>
  <v-dialog
    v-model="display"
    persistent
    max-width="1300"
    @click:outside="handleClose"
  >
    <v-card id="perso-details-modal" class="pa-0">
      <v-card-title class="px-9 py-6">
        <span>{{ $t('device.personalisation.modal.title') }}</span>
        <v-icon id="perso-details-close" @click="handleClose">mdi-close</v-icon>
      </v-card-title>
      <v-divider dark />
      <v-card-text class="pa-6 pt-5">
        <div v-if="perso.rawData" class="perso-details-switch px-3">
          <v-btn
            id="perso-details-vehicle-btn"
            class="perso-details-vehicle-data"
            :class="{ 'perso-details-selected': !showRaw }"
            dark
            outlined

            @click="setShowRawData(false)"
          >
            {{ $t('device.personalisation.modal.vehicle_data') }}
          </v-btn>
          <v-btn
            id="perso-details-raw-btn"
            class="perso-details-raw-data"
            :class="{ 'perso-details-selected': showRaw }"
            dark
            outlined

            @click="setShowRawData(true)"
          >
            {{ $t('device.personalisation.modal.raw_data') }}
          </v-btn>
        </div>
        <DeviceAssociation v-if="persoDetails.vehicleInfo && !showRaw" :persoDetails="persoDetails" />
        <RawData v-else-if="showRaw" :perso="perso" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { Personalisation, PersonalisationDisplayDetails } from 'ctp-personalisation-search';
import { computed, onMounted, PropType, ref } from 'vue';
import useStore from '@/utils/store/common';
import RawData from './components/RawData/RawData.vue';
import DeviceAssociation from './components/DeviceAssociation/DeviceAssociation.vue';

const props = defineProps({
  enabled: {
    type: Boolean,
    default: false
  },
  perso: {
    type: Object as PropType<Personalisation>,
    default: () => ({})
  }
});

const emit = defineEmits(['close']);

const store = useStore();

const persoDetails = ref({} as PersonalisationDisplayDetails);

const showRaw = ref(false);

const display = computed(() => props.enabled);

onMounted(async () => {
  const payload = {
    type: props.perso.type,
    id: props.perso.deviceId,
    masterId: props.perso.masterId,
    version: props.perso.version
  };
  await store.dispatch('personalisation/fetchPersonalisationDetails', payload);
  persoDetails.value = store.getters['personalisation/getPersonalisationDetails'][props.perso.deviceId];
});

function handleClose() {
  emit('close', {});
}

function setShowRawData(value: boolean) {
  showRaw.value = value;
}
</script>
<style lang="scss" scoped>
@import './styles/personalisation-details.scss';
</style>
